import styles from './Option.module.css';

export const Option = (props) => {
    const { item, onClick } = props;
    return (
        <div className={styles.Option} onClick={onClick}>
            {item.label}
        </div>
    );
};
